export const localization = {
	"kz":{
		Header:{
			filter: "Фильтр",
			searchBar: "Мектеп атауы",
			searchButton: "Іздеу",
			university: "Мектептер",
		},
	},
	"ru":{
		Header:{
			filter: "Фильтр",
			searchBar: "Название школы",
			searchButton: "Поиск",
			university: "Школы",
		},
	},
	"en":{
		Header:{
			filter: "Filter",
			searchBar: "School name",
			searchButton: "Search",
			university: "Schools",
		},
	},
}